import React, { Component } from "react";

export default class Banner extends Component {
  render() {
    return (
      <div class="py-5 c2a10">
        <div class="container">
          <div class="row">
            <div class="col-md-5 text-center both-space">
              <div class="card">
                <div class="card-body">
                  <div class="text-box">
                    <h3 class="mb-3">
                      Nothing can be as simple to setup and go live as LIVELMS
                    </h3>
                    <h6 class="subtitle font-weight-normal">
                      Simple to set up, easy to connect live with your students
                    </h6>
                    <a
                      class="btn btn-info-gradiant btn-md border-0 text-white mt-3"
                      href="#"
                    >
                      <span>JOIN NOW</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
